// @flow

import React, { Component } from "react";
import { Field, reduxForm, Form } from "redux-form";
import numberIncrement from "../../../../components/numberIncrement/numberIncrement";
import {
  Button,
  Glyphicon,
  Col,
  Row,
  OverlayTrigger,
  Tooltip
} from "react-bootstrap";
import "./styles.css";
import validate from "./validate";
// import asyncValidate from '../../YourSummaryPanel/form/asyncValidate';

type Props = {
  handleSubmit: Function,
  previousPage: Function,
  onSubmit: Function,
  onSubmitNext: Function
};

class WizardFormThirdPage extends Component<Props> {
  props: Props;

  render() {
    const { handleSubmit, previousPage, onSubmit, help, error, onSubmitNext } = this.props;
    const numberOfSkis = (
      <Tooltip id="tooltip">
        <div
          className={"text-left"}
          dangerouslySetInnerHTML={{ __html: help["numberOfSkis"]["content"] }}
        />
      </Tooltip>
    );
    const numberOfBikes = (
      <Tooltip id="tooltip">
        <div
          className={"text-left"}
          dangerouslySetInnerHTML={{ __html: help["numberOfBikes"]["content"] }}
        />
      </Tooltip>
    );
    const numberOfHoldItems = (
      <Tooltip id="tooltip">
        <div
          className={"text-left"}
          dangerouslySetInnerHTML={{
            __html: help["numberOfHoldItems"]["content"]
          }}
        />
      </Tooltip>
    );
    const loadingSign = () => this.props.isLoading ? (
      <i className="fa fa-spinner fa-spin" />
    ) : null;
    return (
      <Form onSubmit={this.props.form === "transferDetailsOutboundForm" && this.props.isThereAnInboundForm
        ? handleSubmit(onSubmitNext) : handleSubmit(onSubmit)}>
        <Row className="form-three-label">
          <Col xs={6}>Hold luggage</Col>
          <Col xs={4}>
            <Field
              name="holdLuggage"
              component={numberIncrement}
              type="text"
              // onChange={() => handleBlur('holdLuggage')}
            />
          </Col>
          <Col xs={2} style={{ paddingLeft: "6px", color: "grey" }}>
            <OverlayTrigger
              trigger="click"
              placement="bottom"
              overlay={numberOfHoldItems}
            >
              <span className="fa-stack">
                <i className="fa fa-circle-thin fa-stack-2x" />
                <i className="fa fa-info fa-stack-1x" />
              </span>
            </OverlayTrigger>
          </Col>
        </Row>
        <Row className="form-three-label">
          <Col xs={6}>Skis/snowboards</Col>
          <Col xs={4}>
            <Field
              name="skiSnowboards"
              component={numberIncrement}
              type="text"
              // onChange={() => handleBlur('skiSnowboards')}
            />
          </Col>
          <Col xs={2} style={{ paddingLeft: "6px", color: "grey" }}>
            <OverlayTrigger
              trigger="click"
              placement="bottom"
              overlay={numberOfSkis}
            >
              <span className="fa-stack">
                <i className="fa fa-circle-thin fa-stack-2x" />
                <i className="fa fa-info fa-stack-1x" />
              </span>
            </OverlayTrigger>
          </Col>
        </Row>
        <Row className="form-three-label">
          <Col xs={6}>Bikes/Golf Bags</Col>
          <Col xs={4}>
            <Field
              name="bikesSurfboards"
              component={numberIncrement}
              type="text"
              // onChange={() => handleBlur('bikesSurfboards')}
            />
          </Col>
          <Col xs={2} style={{ paddingLeft: "6px", color: "#7a7a7a" }}>
            <OverlayTrigger
              trigger="click"
              placement="bottom"
              overlay={numberOfBikes}
            >
              <span className="fa-stack">
                <i className="fa fa-circle-thin fa-stack-2x" />
                <i className="fa fa-info fa-stack-1x" />
              </span>
            </OverlayTrigger>
          </Col>
        </Row>
        {error && (
          <strong style={{ color: "red", marginLeft: "5px" }}>{error}</strong>
        )}
        <div className="next-button">
          {this.props.form === "transferDetailsOutboundForm" &&
          this.props.isThereAnInboundForm ? (
            <Button
              bsSize="large"
              bsStyle="success"
              type="submit"
              disabled={this.props.submitting}
              className="next"
              onFocus={() => this.props.handleBlur("")}
            >
             <span>ADD RETURN</span>
            </Button>
          ) : (
            <Button
              bsSize="large"
              bsStyle="success"
              type="submit"
              className="next"
            >
              <span>Next</span>
              {loadingSign()}
            </Button>
          )}

          <Button
            bsStyle="link"
            type="button"
            className="previous"
            onClick={previousPage}
          >
            <Glyphicon glyph="arrow-left" /> See previous screen
          </Button>
        </div>
      </Form>
    );
  }
}

export default reduxForm({
  enableReinitialize: true,
  keepDirtyOnReinitialize: false,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate
  // asyncValidate
})(WizardFormThirdPage);



// WEBPACK FOOTER //
// ./src/containers/QuotePage/TravelDetailsPanel/form/WizardFormThirdPage.js